(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[214],{

/***/ 2207:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gallery",
      function () {
        return __webpack_require__(8334);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ gallery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/data/GalleryData.js
const GalleryData = [
    //  first view images
    {
        "image": "/images/gallery/view/adventure-resort-view-1.jpg",
        "category": "View"
    },
    {
        "image": "/images/gallery/view/adventure-resort-view-2.jpg",
        "category": "View"
    },
    //  first activities images
    {
        "image": "/images/gallery/activities/Activity-17.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-9.jpg",
        "category": "Activities"
    },
    //  first accomodation images
    {
        "image": "/images/gallery/rooms/room-img1.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img6.jpg",
        "category": "Accommodation"
    },
    //  first Dining images
    {
        "image": "/images/gallery/dinning/Dinning_21.jpg",
        "category": "Dining"
    },
    //  first Video images
    {
        "videoUrl": "4o9FDWomIiU",
        "category": "Videos"
    },
    //  first banquet images
    {
        "image": "/images/gallery/banquet/Banquet_12.jpg",
        "category": "Wedding & Events"
    },
    // View
    {
        "image": "/images/gallery/view/adventure-resort-view-3.jpg",
        "category": "View"
    },
    {
        "image": "/images/gallery/view/adventure-resort-view-4.jpg",
        "category": "View"
    },
    {
        "image": "/images/gallery/view/adventure-resort-view-5.jpg",
        "category": "View"
    },
    // Activities
    {
        "image": "/images/gallery/activities/Activity-1.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-2.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-3.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-4.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-5.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-6.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-7.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-8.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-10.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-11.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-12.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-13.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-14.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-15.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-16.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-18.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-19.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-20.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-21.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-22.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-23.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-24.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-25.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-26.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-27.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-28.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-29.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-30.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-31.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-32.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-33.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-34.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-35.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-36.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-37.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-38.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-39.jpg",
        "category": "Activities"
    },
    {
        "image": "/images/gallery/activities/Activity-40.jpg",
        "category": "Activities"
    },
    // Accomodation
    {
        "image": "/images/gallery/rooms/room-img3.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img4.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img5.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img2.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img7.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img8.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img9.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img10.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img11.jpg",
        "category": "Accommodation"
    },
    {
        "image": "/images/gallery/rooms/room-img12.jpg",
        "category": "Accommodation"
    },
    // Dining
    {
        "image": "/images/gallery/dinning/Dinning_2.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_3.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_4.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_6.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_7.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_8.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_9.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_10.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_11.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_12.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_13.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_14.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_15.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_16.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_17.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_18.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_19.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_20.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_1.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_22.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_23.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_24.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_25.jpg",
        "category": "Dining"
    },
    {
        "image": "/images/gallery/dinning/Dinning_26.jpg",
        "category": "Dining"
    },
    // Videos
    {
        "videoUrl": "wAn1MtgrA3E",
        "category": "Videos"
    },
    // Banquet
    {
        "image": "/images/gallery/banquet/Banquet_2.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_3.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_4.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_5.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_6.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_7.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_8.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_9.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_10.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_11.jpg",
        "category": "Wedding & Events"
    },
    {
        "image": "/images/gallery/banquet/Banquet_1.jpg",
        "category": "Wedding & Events"
    }
];
/* harmony default export */ var data_GalleryData = (GalleryData);
{}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/GalleryComponent/GalleryComponent.module.scss
var GalleryComponent_module = __webpack_require__(8023);
var GalleryComponent_module_default = /*#__PURE__*/__webpack_require__.n(GalleryComponent_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/GalleryComponent/GalleryComponent.js




const GalleryComponent = (param)=>{
    let { GalleryData  } = param;
    const [activeLink, setActiveLink] = (0,react.useState)("All");
    const [filteredData, setFilteredData] = (0,react.useState)(GalleryData);
    const [visibleItems, setVisibleItems] = (0,react.useState)(9); // State to track number of visible items
    const [loading, setLoading] = (0,react.useState)(true); // State to track loading
    const tabs = [
        "All",
        "View",
        "Activities",
        "Accommodation",
        "Dining",
        "Videos",
        "Wedding & Events"
    ];
    const [modalOpen, setModalOpen] = (0,react.useState)(false);
    const [selectedImage, setSelectedImage] = (0,react.useState)(null);
    const handleTabChange = (tab)=>{
        let filteredItem;
        setLoading(true); // Show skeleton loader when switching tabs
        if (tab === "All") {
            filteredItem = GalleryData;
        } else {
            filteredItem = GalleryData.filter((item)=>item.category === tab);
        }
        setFilteredData(filteredItem);
        setActiveLink(tab);
        setVisibleItems(9); // Reset visible items when switching tabs
        setTimeout(()=>{
            setLoading(false); // Hide skeleton loader after loading
        }, 1000); // Simulate loading time
    };
    const loadMoreItems = ()=>{
        setLoading(true); // Show skeleton loader when loading more items
        setTimeout(()=>{
            setVisibleItems((prevVisibleItems)=>prevVisibleItems + 9);
            setLoading(false); // Hide skeleton loader after loading more items
        }, 1000); // Simulate loading time
    };
    (0,react.useEffect)(()=>{
        // Set initial data to show all items
        setFilteredData(GalleryData);
        setLoading(false); // Hide skeleton loader after initial load
    }, [
        GalleryData
    ]);
    const displayedData = filteredData.slice(0, visibleItems);
    const showLoadMore = filteredData.length > visibleItems;
    //...................Gallery Modal......................
    const openModal = (imageData)=>{
        setSelectedImage(imageData);
        setModalOpen(true);
    };
    const closeModal = ()=>{
        setModalOpen(false);
        setSelectedImage(null); // Reset selected image when closing modal
    };
    const goToPrevious = (e)=>{
        e.stopPropagation();
        const currentIndex = filteredData.indexOf(selectedImage);
        const prevIndex = currentIndex === 0 ? filteredData.length - 1 : currentIndex - 1;
        setSelectedImage(filteredData[prevIndex]);
    };
    const goToNext = (e)=>{
        e.stopPropagation();
        const currentIndex = filteredData.indexOf(selectedImage);
        const nextIndex = currentIndex === filteredData.length - 1 ? 0 : currentIndex + 1;
        setSelectedImage(filteredData[nextIndex]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (GalleryComponent_module_default()).gallery_tab_bar,
                children: tabs.map((tab, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: activeLink === tab ? "".concat((GalleryComponent_module_default()).active_tab) : "",
                        onClick: ()=>handleTabChange(tab),
                        children: tab
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (GalleryComponent_module_default()).gallery_card_parent,
                children: [
                    displayedData.map((filteredProperty, index)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: (GalleryComponent_module_default()).gallery_card_img_parent,
                            onClick: ()=>openModal(filteredProperty),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (GalleryComponent_module_default()).gallery_card_img,
                                children: (filteredProperty === null || filteredProperty === void 0 ? void 0 : filteredProperty.videoUrl) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (GalleryComponent_module_default()).video_wrapper,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (GalleryComponent_module_default()).overlay,
                                            onClick: ()=>openModal(filteredProperty)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                            width: "100%",
                                            height: "100%",
                                            src: "https://www.youtube.com/embed/".concat(filteredProperty === null || filteredProperty === void 0 ? void 0 : filteredProperty.videoUrl, "?autoplay=1&loop=1&playlist=").concat(filteredProperty === null || filteredProperty === void 0 ? void 0 : filteredProperty.videoUrl, "&mute=1&modestbranding=1&controls=0&rel=0"),
                                            title: "YouTube video player",
                                            frameBorder: "0",
                                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                            allowFullScreen: true,
                                            style: {
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover"
                                            }
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        height: "100%",
                                        position: "relative"
                                    },
                                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (GalleryComponent_module_default()).skeleton
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: filteredProperty === null || filteredProperty === void 0 ? void 0 : filteredProperty.image,
                                        alt: "",
                                        fill: true,
                                        sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw",
                                        onLoadingComplete: ()=>setLoading(false)
                                    })
                                })
                            })
                        }, index);
                    }),
                    modalOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (GalleryComponent_module_default()).modal_overlay,
                        onClick: closeModal,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: (GalleryComponent_module_default()).close_button,
                                onClick: closeModal,
                                children: "\xd7"
                            }),
                            selectedImage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    selectedImage.videoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        width: "100%",
                                        height: "100%",
                                        src: "https://www.youtube.com/embed/".concat(selectedImage.videoUrl, "?autoplay=1&loop=1&playlist=").concat(selectedImage.videoUrl, "&mute=1&modestbranding=1&controls=0&rel=0"),
                                        title: "YouTube video player",
                                        frameBorder: "0",
                                        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                        allowFullScreen: true,
                                        style: {
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: selectedImage.image,
                                        className: (GalleryComponent_module_default()).modal_image,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (GalleryComponent_module_default()).prev_button,
                                        onClick: goToPrevious,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "24px",
                                            viewBox: "0 -960 960 960",
                                            width: "24px",
                                            fill: "#fff",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (GalleryComponent_module_default()).next_button,
                                        onClick: goToNext,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "24px",
                                            viewBox: "0 -960 960 960",
                                            width: "24px",
                                            fill: "#fff",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"
                                            })
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (GalleryComponent_module_default()).loader
                            })
                        ]
                    })
                ]
            }),
            showLoadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "common_btn",
                    onClick: loadMoreItems,
                    children: "Load More"
                })
            })
        ]
    });
};
/* harmony default export */ var GalleryComponent_GalleryComponent = (GalleryComponent);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Reusable/Banner/Topbanner.module.scss
var Topbanner_module = __webpack_require__(4199);
var Topbanner_module_default = /*#__PURE__*/__webpack_require__.n(Topbanner_module);
;// CONCATENATED MODULE: ./src/components/Reusable/Banner/WithoutImageBanner.js


function WithoutImageBanner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (Topbanner_module_default()).without_image_banner
        })
    });
}
/* harmony default export */ var Banner_WithoutImageBanner = (WithoutImageBanner);

;// CONCATENATED MODULE: ./src/pages/gallery/index.js





const Gallery = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Gallery | Adventure Resorts"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.adventureresortkufri.com/gallery"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner_WithoutImageBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "common_padding pb-0",
                id: "firstsec",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row justify-content-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-8 common_title text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Gallery"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Adventure Resorts Shimla offers the ultimate student destination, boasting thrilling activities and attractions amidst Himachal Pradesh's scenic landscapes."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryComponent_GalleryComponent, {
                                GalleryData: data_GalleryData
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var gallery = (Gallery);


/***/ }),

/***/ 8023:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery_tab_bar":"GalleryComponent_gallery_tab_bar__i7GNw","active_tab":"GalleryComponent_active_tab__4p6DA","gallery_card_parent":"GalleryComponent_gallery_card_parent__Bje3a","gallery_card_img_parent":"GalleryComponent_gallery_card_img_parent__yVRDq","gallery_card_img":"GalleryComponent_gallery_card_img__mTZvG","video_wrapper":"GalleryComponent_video_wrapper__o7KiL","overlay":"GalleryComponent_overlay__CSbC0","modal_overlay":"GalleryComponent_modal_overlay__JMQUc","loader":"GalleryComponent_loader__RUtNF","l27":"GalleryComponent_l27__18Iya","close_button":"GalleryComponent_close_button__NqWm4","prev_button":"GalleryComponent_prev_button__naXkM","next_button":"GalleryComponent_next_button__TWAXH","skeleton":"GalleryComponent_skeleton__HNn5q","loading":"GalleryComponent_loading__TRWsR"};

/***/ }),

/***/ 4199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_banner":"Topbanner_top_banner__JLDvP","banner_text":"Topbanner_banner_text__znygP","banner_btn":"Topbanner_banner_btn___Zjwb","down":"Topbanner_down__3Pfwj","home_banner":"Topbanner_home_banner__p1RdH","banner_text_con":"Topbanner_banner_text_con__K9pZF","without_image_banner":"Topbanner_without_image_banner__U6U0K"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2207); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);